import {useEffect, useState} from "react";
import {get_movies} from "../../../server/requests";
import RowList from "../../Row_List/RowList";
import Loading from "../../Loading/Loading";

export default function Movies({isGuest}) {
    const [listMovies, setListMovies] = useState([])
    const [loadingShow, setLoadingShow] = useState(false)
    useEffect(() => {
        setLoadingShow(true)
        get_movies({}, data => {
            setListMovies([...data])
            setLoadingShow(false)
        })
    }, [])
    return (
        <div className="container">
            <div className="list_movies">
                {loadingShow ?
                    <Loading/>
                    : listMovies.map((row, index) => {
                        return row.movies && row.movies.length ?
                            <RowList
                                key={row.id}
                                title={row.name}
                                type={'movies'}
                                row={row}
                                array={row.movies}
                                rowIndex={index}
                                isGuest={isGuest}

                            /> : null

                    })}
            </div>
        </div>
    )
}